/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_TranscriptionInputs */

const en_offline_transcription = /** @type {(inputs: Offline_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline Transcription`)
};

const fr_offline_transcription = /** @type {(inputs: Offline_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription hors ligne`)
};

const de_offline_transcription = /** @type {(inputs: Offline_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline-Transkription`)
};

const it_offline_transcription = /** @type {(inputs: Offline_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione offline`)
};

const ru_offline_transcription = /** @type {(inputs: Offline_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Офлайн-транскрипция`)
};

const es_offline_transcription = /** @type {(inputs: Offline_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripción sin conexión`)
};

const zh_cn2_offline_transcription = /** @type {(inputs: Offline_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`离线转录`)
};

const ja_offline_transcription = /** @type {(inputs: Offline_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフライン文字起こし`)
};

const hi_offline_transcription = /** @type {(inputs: Offline_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़लाइन प्रतिलेखन`)
};

const pt_pt2_offline_transcription = /** @type {(inputs: Offline_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrição offline`)
};

/**
* | output |
* | --- |
* | "Offline Transcription" |
*
* @param {Offline_TranscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_transcription = /** @type {((inputs?: Offline_TranscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_TranscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_transcription(inputs)
	if (locale === "de") return de_offline_transcription(inputs)
	if (locale === "it") return it_offline_transcription(inputs)
	if (locale === "ru") return ru_offline_transcription(inputs)
	if (locale === "es") return es_offline_transcription(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_transcription(inputs)
	if (locale === "ja") return ja_offline_transcription(inputs)
	if (locale === "hi") return hi_offline_transcription(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_transcription(inputs)
	return en_offline_transcription(inputs)
});